import { usePageTracking } from "@/hooks/usePageTracking";

export const PageTracker = ({ children }: { children: React.ReactNode }) => {
  usePageTracking();
  return <>{children}</>;
};
